module.exports = __webpack_public_path__ + "img/square-dark-monochrome-transparent.587f95b.svg";